export const css = {
	root: '_27NxZbSD',
	' _key': 'certwise-theme/dojo/variants/default'
};

export default css;
